/* Restyle the existing Shopify Forms teaser; Shopify retains the form,
 * click handler, dismissal preferences, submission and discount delivery. */
(() => {
  'use strict';
  const hostId = 'app-embed-container-654717';
  const styleId = 'fellino-gift-teaser-style';
  // Restore the teaser for visitors who closed the old, non-reopenable form.
  // Run once before Shopify Forms loads; preserve completed signups and future
  // dismissal choices. Shopify still owns opening, validation and submitting.
  try {
    const migratedKey = 'fellino-gift-reopenable-v1';
    const dismissedKey = '654717-dismissed-in-session';
    if (!localStorage.getItem(migratedKey)) {
      if (!localStorage.getItem('654717-dismissed-after-submit') && localStorage.getItem(dismissedKey)) {
        localStorage.setItem('654717-minimized-in-session', '654717');
        localStorage.removeItem(dismissedKey);
      }
      localStorage.setItem(migratedKey, '1');
    }
  } catch (_) {
    // Storage restrictions must not prevent launcher styling from loading.
  }
  const gift = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"><path d="M14 9C9 9 6 8 6 5.8 6 2.6 11 3.3 14 9Zm0 0c5 0 8-1 8-3.2 0-3.2-5-2.5-8 3.2Z" fill="none" stroke="#f4c66a" stroke-width="2" stroke-linejoin="round"/><rect x="5" y="12" width="18" height="12" rx="2" fill="#eeb957"/><rect x="3" y="9" width="22" height="5" rx="1.5" fill="#ffda8b"/><path d="M12 9h4v15h-4Z" fill="#b6503f"/><path d="M5 15h18" stroke="#d49b3d" stroke-width="1" opacity=".6"/><path d="M12 14h4" stroke="#d37962" stroke-width="1"/></svg>';
  const css = `
    #app-embed[data-current-step="tease"] {
      position: fixed !important;
      inset: auto auto max(20px, env(safe-area-inset-bottom)) max(20px, env(safe-area-inset-left)) !important;
      width: 50px !important; height: 50px !important;
      padding: 0 !important; margin: 0 !important;
      transform: none !important; rotate: none !important;
      z-index: 40 !important;
    }
    #app-embed[data-current-step="tease"] [data-testid="app-router"] {
      width: 50px !important; height: 50px !important;
      padding: 0 !important; margin: 0 !important;
      transform: none !important; rotate: none !important; animation: none !important;
    }
    #app-embed [data-testid="form-teaser"] {
      box-sizing: border-box !important;
      display: block !important;
      width: 50px !important; min-width: 50px !important; max-width: 50px !important;
      height: 50px !important; min-height: 50px !important;
      padding: 0 !important; margin: 0 !important;
      border: 1px solid #476554 !important; border-radius: 50% !important;
      background: #304b3f url("data:image/svg+xml,${encodeURIComponent(gift)}") center / 30px 30px no-repeat !important;
      box-shadow: 0 4px 16px #243d3240 !important;
      transform: none !important; rotate: none !important;
      cursor: pointer; transition: background-color 150ms ease, box-shadow 150ms ease;
    }
    #app-embed [data-testid="form-teaser"] > * { display: none !important; }
    #app-embed [data-testid="form-teaser"]:hover {
      background-color: #3e604e !important; box-shadow: 0 5px 18px #243d3250 !important;
    }
    #app-embed [data-testid="form-teaser"]:focus-visible {
      outline: 2px solid #304b3f !important; outline-offset: 4px !important;
    }
    @media (max-width: 599px) {
      #app-embed[data-current-step="tease"] {
        left: max(20px, env(safe-area-inset-left)) !important;
        bottom: max(20px, env(safe-area-inset-bottom)) !important;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      #app-embed [data-testid="form-teaser"] { transition: none !important; }
    }
  `;
  function attach() {
    const root = document.getElementById(hostId)?.shadowRoot;
    if (!root) return false;
    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId; style.textContent = css; root.append(style);
    }
    return true;
  }
  if (attach()) return;
  // The app loads asynchronously and its open shadow root is created separately.
  let attempts = 0;
  const timer = setInterval(() => {
    if (attach() || ++attempts >= 300) clearInterval(timer);
  }, 100);
})();
